import React from 'react';
import { Link } from 'react-router-dom';

export default function AppFooter() {
  return (
    <footer className="bg-[#1C2127] border-t border-[#3A424D] py-4 px-4 mt-auto">
      <div className="max-w-6xl mx-auto">
        {/* Compact Disclaimer */}
        <div className="bg-[#FF6B35]/10 border border-[#FF6B35]/30 rounded-lg p-3 mb-4">
          <p className="text-xs text-[#ADB5BD] leading-snug">
            <strong className="text-[#FF6B35]">⚠️ Peer support only, not therapy.</strong> Crisis: 🇺🇸 988/911 • 🇬🇧 999/116 123 • 🇦🇺 000/13 11 14. Not HIPAA-covered. 18+ only.
          </p>
        </div>

        {/* Compact Links Grid */}
        <div className="grid grid-cols-3 gap-4 mb-3 text-xs">
          {/* Crisis */}
          <div>
            <p className="font-semibold text-white mb-1">Crisis Resources</p>
            <div className="text-[#ADB5BD] space-y-0.5">
              <p>🇺🇸 <a href="tel:988" className="hover:text-[#00B4D8]">988</a> / <a href="tel:911" className="hover:text-[#00B4D8]">911</a></p>
              <p>🇬🇧 <a href="tel:116123" className="hover:text-[#00B4D8]">116 123</a> / <a href="tel:999" className="hover:text-[#00B4D8]">999</a></p>
              <p>🇦🇺 <a href="tel:131114" className="hover:text-[#00B4D8]">13 11 14</a> / <a href="tel:000" className="hover:text-[#00B4D8]">000</a></p>
              <a href="https://findahelpline.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#00B4D8]">More →</a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <p className="font-semibold text-white mb-1">Legal</p>
            <div className="text-[#ADB5BD] space-y-0.5">
              <Link to="/privacy" className="hover:text-[#00B4D8] block">Privacy</Link>
              <Link to="/terms" className="hover:text-[#00B4D8] block">Terms</Link>
              <a href="mailto:legal@iam-buddy.app" className="hover:text-[#00B4D8] block">Legal</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="font-semibold text-white mb-1">Contact</p>
            <div className="text-[#ADB5BD] space-y-0.5">
              <a href="mailto:support@iam-buddy.app" className="hover:text-[#00B4D8] block">Support</a>
              <a href="mailto:privacy@iam-buddy.app" className="hover:text-[#00B4D8] block">Privacy</a>
              <a href="mailto:security@iam-buddy.app" className="hover:text-[#00B4D8] block">Security</a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center pt-2 border-t border-[#3A424D]">
          <p className="text-xs text-[#6C757D]">
            © {new Date().getFullYear()} i am buddy • Hayley & Pieter, Adelaide SA • Evidence-based recovery support
          </p>
        </div>
      </div>
    </footer>
  );
}
